import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Loginform from '../components/Loginform';

const Login = () => {
    return (
        <div>
            <Header />
            <Loginform />
            <Footer />
        </div>
    );
};

export default Login;
